import React from "react";
import { Badge, Image } from "react-bootstrap";
import ExpertBio from "./ExpertBio";
import { adminExpertProfileUrl } from "./expertProfile";

const CARD_AVATAR_SIZE = 40;

// Renders the currently-selected experts as mini cards, sitting outside the
// ExpertPickerForm's border. Each card shows name, optional title · company,
// a short bio snippet, and a small X button to remove. The whole component
// returns null when nothing is selected.
export default function SelectedExperts({ experts, publishabilityById = {}, onRemove }) {
  if (!experts || experts.length === 0) return null;

  // Auto-fill grid: as many 220px-min columns as the row can fit, each
  // growing to share the remaining width. On a wide form column you get
  // two cards per row; narrow columns fall back to one per row without
  // any media-query gymnastics.
  return (
    <div
      className="mt-3"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
        gap: "0.5rem",
      }}
    >
      {experts.map((expert) => (
        <SelectedExpertCard
          key={expert.id}
          expert={expert}
          isPublishable={publishabilityById[expert.id]}
          onRemove={onRemove}
        />
      ))}
    </div>
  );
}

function SelectedExpertCard({ expert, isPublishable, onRemove }) {
  const titleLine = [expert.title, expert.company].filter(Boolean).join(" · ");
  const profileUrl = adminExpertProfileUrl(expert);
  return (
    <div className="border rounded p-2 bg-white d-flex gap-2">
      <Image
        roundedCircle
        src={expert.profile_image_url}
        alt=""
        style={{
          width: `${CARD_AVATAR_SIZE}px`,
          height: `${CARD_AVATAR_SIZE}px`,
          objectFit: "cover",
          flexShrink: 0,
        }}
      />
      <div className="flex-grow-1" style={{ minWidth: 0 }}>
        <div className="d-flex justify-content-between align-items-start gap-2">
          <div className="flex-grow-1" style={{ minWidth: 0 }}>
            <div className="fw-semibold text-truncate">
              {profileUrl ? (
                <a href={profileUrl} target="_blank" rel="noreferrer">
                  {expert.name}
                </a>
              ) : (
                expert.name
              )}
            </div>
            {titleLine && <div className="text-muted small text-truncate">{titleLine}</div>}
          </div>
          <button
            type="button"
            className="border-0 d-inline-flex align-items-center justify-content-center selected-expert-remove"
            onClick={() => onRemove(expert.id)}
            aria-label={`Remove ${expert.name}`}
            title={`Remove ${expert.name}`}
            style={{
              width: 18,
              height: 18,
              borderRadius: "50%",
              backgroundColor: "var(--bs-gray-400)",
              color: "white",
              fontSize: "0.7rem",
              lineHeight: 1,
              cursor: "pointer",
              padding: 0,
              flexShrink: 0,
              transition: "background-color 120ms ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "var(--bs-gray-600)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "var(--bs-gray-400)";
            }}
          >
            <i className="fa-solid fa-xmark" aria-hidden="true" />
          </button>
        </div>
        <ExpertBio description={expert.description} />
        {isPublishable === false && (
          <Badge bg="warning" text="dark" className="mt-1">
            No longer publishable
          </Badge>
        )}
      </div>
    </div>
  );
}
